import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, Text, useResponsive } from '@common-fe/common-fe';

// @ts-ignore
import elevateDisclosureAndConsent from '@/assets/docs/ELEVATE ESIGN DISCLOSURE AND CONSENT v1.pdf';
import { useTermsAndConditionsDocsQuery } from '@/modules/investments/docs';
import { StyledAnchor } from '@/modules/transaction/components/Statements/components/ElectronicAgreement/ElectronicAgreement.styles';
import globalTheme from '@/styles/theme';
export const Doc = elevateDisclosureAndConsent;
export interface ElectronicAgreementCheckboxProps {
  isChecked: boolean;
  onChecked: () => void;
  isError?: boolean;
  fontSize?: string;
}

const ElectronicAgreementCheckbox: React.FC<ElectronicAgreementCheckboxProps> = ({
  isChecked,
  onChecked,
  isError,
  fontSize,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { electronicDisclosureAgreementLink } = useTermsAndConditionsDocsQuery();

  return (
    <Box direction="row" align={isMobile ? 'start' : 'center'}>
      <Checkbox
        checked={isChecked}
        onChange={onChecked}
        error={isError}
        isLarge={isMobile}
        backgroundColor={globalTheme.colors.canvas}
        testId="electronic-agreement"
        name="electronic-agreement"
      >
        <Box margin={isMobile ? { left: 'spacing12' } : {}}>
          <Text size={fontSize || 'large'}>
            {t('I would like to receive paperless statements and letters.')}
          </Text>
          <Text size={fontSize || 'large'}>
            {t('I have read and accept the')}&nbsp;
            <StyledAnchor size={fontSize || 'large'} href={electronicDisclosureAgreementLink} target="_blank">
              {t('Electronic Disclosure Agreement.')}
            </StyledAnchor>
          </Text>
        </Box>
      </Checkbox>
    </Box>
  );
};

export default ElectronicAgreementCheckbox;
